import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-image',
    templateUrl: './modal-image.component.html',
    styleUrls: ['./modal-image.component.scss'],
})
export class ModalImageComponent implements OnDestroy {
    destroy$ = new Subject();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        private dialogRef: MatDialogRef<ModalImageComponent>,
    ) {}

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    close() {
        this.dialogRef.close();
    }
}
